import React from "react";
import { Switch } from "react-router-dom";
import ProtectedRoute from "./PrivateRoute";
import PackagesAndGroupsReport from "@modules/reports/pages/packages-and-groups-report";
import MicroprogrammingGroupsReport from "@modules/reports/pages/microprogramming-groups-report";

const base = "/report";
const context = ":workspace/:scenario/:origin";

export const moduleRoutes = [
  {
    path: `${base}/packages-and-groups/${context}`,
    component: PackagesAndGroupsReport,
    name: "PackagesAndGroupsReport",
  },
  {
    path: `${base}/microprogramming-groups/${context}`,
    component: MicroprogrammingGroupsReport,
    name: "MicroprogrammingGroupsReport",
  },
];

const RouteDimensions: React.FC = (props: any) => (
  <Switch>
    {moduleRoutes.map((route, index) => (
      <ProtectedRoute
        key={index + props.location.key}
        path={route.path}
        component={route.component}
        exact
      />
    ))}
  </Switch>
);

export default RouteDimensions;
